import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron_down_thin",
  "use": "chevron_down_thin-usage",
  "viewBox": "0 0 16 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 24\" id=\"chevron_down_thin\"><path d=\"M6.979 13.813 10.792 10l.541.542-4.083 4.083h-.542l-4.083-4.083.541-.542z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol